// libs
import React, { useState } from 'react';
import cx from 'classnames';
// dls
import { Checkbox } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
// widgets
import ProductDetails from '@/components/ProductDetails';
// styles
import styles from '../ProductSearch.module.scss';
const ProductOption = ({ className, selected, item, onChange }) => {
    var _a;
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = () => {
        setIsExpanded((val) => !val);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(className, {
                [styles.variant]: item.isVariant,
            }) },
            React.createElement(ProductDetails, { creativeId: item.creativeId, title: item.title, subTitle: item.description, expandable: true, variants: item.variants, onExpand: toggleExpand, onCollapse: toggleExpand }),
            React.createElement("span", { onMouseDown: onChange },
                React.createElement(Checkbox, { label: "", orientation: "rtl", id: item.id, checked: selected }))),
        ((_a = item.variants) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement("div", { className: cx(styles.variants, {
                [styles.variantsVisible]: isExpanded,
            }) }, item.variants.map((variant) => {
            return (React.createElement("div", { key: variant.id, className: cx(className, styles.variantsItem) },
                React.createElement(ProductDetails, { asVariant: true, creativeId: variant.creativeId, subTitle: variant.description })));
        }))) : null));
};
export default ProductOption;
